function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 20.8306,
  cy: 21.5469,
  r: 20.75,
  fill: "#4CB8AE"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.8843 18.003H16.3083V19.023H12.1083V21.699H16.0683V22.719H12.1083V26.547H10.8843V18.003Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M20.4311 26.643C19.7671 26.643 19.1591 26.555 18.6071 26.379C18.0631 26.203 17.5911 25.939 17.1911 25.587L17.6351 24.675C18.0511 25.011 18.4831 25.255 18.9311 25.407C19.3791 25.559 19.8831 25.635 20.4431 25.635C21.0831 25.635 21.5791 25.515 21.9311 25.275C22.2831 25.035 22.4591 24.695 22.4591 24.255C22.4591 23.887 22.2951 23.611 21.9671 23.427C21.6391 23.235 21.1191 23.059 20.4071 22.899C19.7271 22.755 19.1711 22.591 18.7391 22.407C18.3071 22.215 17.9671 21.963 17.7191 21.651C17.4711 21.331 17.3471 20.923 17.3471 20.427C17.3471 19.931 17.4791 19.495 17.7431 19.119C18.0071 18.735 18.3791 18.439 18.8591 18.231C19.3471 18.015 19.9071 17.907 20.5391 17.907C21.1391 17.907 21.6991 17.999 22.2191 18.183C22.7471 18.367 23.1871 18.627 23.5391 18.963L23.0951 19.875C22.7031 19.547 22.2991 19.307 21.8831 19.155C21.4671 18.995 21.0231 18.915 20.5511 18.915C19.9351 18.915 19.4511 19.047 19.0991 19.311C18.7471 19.567 18.5711 19.919 18.5711 20.367C18.5711 20.751 18.7231 21.043 19.0271 21.243C19.3391 21.443 19.8351 21.623 20.5151 21.783C21.2271 21.943 21.8031 22.111 22.2431 22.287C22.6831 22.463 23.0351 22.703 23.2991 23.007C23.5631 23.311 23.6951 23.703 23.6951 24.183C23.6951 24.679 23.5631 25.111 23.2991 25.479C23.0351 25.847 22.6551 26.135 22.1591 26.343C21.6711 26.543 21.0951 26.643 20.4311 26.643Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M30.9862 24.435H26.6662L25.7542 26.547H24.4942L28.2982 18.003H29.3422L33.1582 26.547H31.8982L30.9862 24.435ZM30.5662 23.451L28.8262 19.383L27.0862 23.451H30.5662Z",
  fill: "white"
});

var SvgFsa = function SvgFsa(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFsa, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fsa.26b29068.svg";
export { ForwardRef as ReactComponent };